/**
 * Chat status predicates.
 *
 * The Vercel AI SDK `useChat` status transitions `ready → submitted → streaming
 * → ready` (or `→ error`). "Busy" must include BOTH `submitted` and `streaming`:
 * during the `submitted` window the request is in flight but no token has arrived
 * yet (seconds on a cold Bedrock call or a tool round-trip). Gating send/disable
 * on `streaming` alone leaves a hole where a second concurrent send — or a
 * double-clicked tool approval — slips through. Every "is the chat busy?" guard
 * must use {@link isBusyStatus}.
 */

/** True while a request is in flight OR streaming (the composer/approvals should be locked). */
export function isBusyStatus(status: string | undefined | null): boolean {
  return status === 'submitted' || status === 'streaming';
}

/** True only while tokens are actively streaming back (narrower than {@link isBusyStatus}). */
export function isStreamingStatus(status: string | undefined | null): boolean {
  return status === 'streaming';
}

/** True when the last turn failed and a retry should be offered. */
export function isErrorStatus(status: string | undefined | null): boolean {
  return status === 'error';
}
